import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";

const CONF_OPTIONS = [
  { key: "confTehnice", label: "Informatii tehnice si tehnologice" },
  { key: "confFinanciare", label: "Informatii financiare si comerciale" },
  { key: "confClienti", label: "Liste de clienti si furnizori" },
  { key: "confStrategii", label: "Strategii de afaceri si planuri de dezvoltare" },
  { key: "confCod", label: "Cod sursa si documentatie tehnica" },
  { key: "confDate", label: "Date personale si informatii despre angajati" },
];

function Checkbox({ label, checked, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px 16px",
        backgroundColor: checked ? "rgba(196, 93, 62, 0.05)" : "#fdfbf7",
        borderRadius: "8px",
        border: `1.5px solid ${checked ? "rgba(196, 93, 62, 0.2)" : "#e8e0d4"}`,
        cursor: "pointer",
        transition: "all 0.2s ease",
      }}
      onClick={onChange}
    >
      <div style={{
        width: "20px",
        height: "20px",
        borderRadius: "4px",
        border: `2px solid ${checked ? "#c45d3e" : "#d4cdc0"}`,
        backgroundColor: checked ? "#c45d3e" : "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        transition: "all 0.2s ease",
      }}>
        {checked && (
          <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
            <path d="M1 5L4.5 8.5L11 1.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </div>
      <span style={{ fontSize: "14px", color: "#2d2418", fontFamily: "'DM Sans', sans-serif" }}>
        {label}
      </span>
    </div>
  );
}

export default function DetaliiStep({ data, errors, update, toggleField }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField
        label="Scopul acordului"
        value={data.scop}
        onChange={update("scop")}
        placeholder="ex: Evaluarea unei potentiale colaborari comerciale / Prestarea serviciilor de dezvoltare software / Discutii privind un parteneriat de afaceri"
        required
        error={errors.scop}
      />

      <div style={{ width: "100%" }}>
        <div style={{ fontSize: "15px", fontWeight: 600, color: "#2d2418", fontFamily: "'DM Sans', sans-serif", marginBottom: "8px" }}>
          Informatii considerate confidentiale
        </div>
        {errors.confInfo && (
          <div style={{ fontSize: "13px", color: "#c45d3e", marginBottom: "8px", fontFamily: "'DM Sans', sans-serif" }}>
            {errors.confInfo}
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {CONF_OPTIONS.map((opt) => (
            <Checkbox
              key={opt.key}
              label={opt.label}
              checked={!!data[opt.key]}
              onChange={toggleField(opt.key)}
            />
          ))}
          <Checkbox
            label="Altele (specifica mai jos)"
            checked={!!data.confAltele}
            onChange={toggleField("confAltele")}
          />
          {data.confAltele && (
            <InputField
              label="Alte informatii confidentiale"
              value={data.confAlteleText}
              onChange={update("confAlteleText")}
              placeholder="ex: Brevet de inventie, retete, formule proprii"
            />
          )}
        </div>
      </div>

      <SelectField
        label="Durata obligatiei de confidentialitate dupa incetarea acordului"
        value={data.durataObligatie}
        onChange={update("durataObligatie")}
        options={[
          { value: "1", label: "1 an" },
          { value: "2", label: "2 ani" },
          { value: "3", label: "3 ani" },
          { value: "5", label: "5 ani" },
        ]}
        half
      />

      <SelectField
        label="Durata acordului"
        value={data.durataAcord}
        onChange={update("durataAcord")}
        options={[
          { value: "colaborare", label: "Pe durata colaborarii" },
          { value: "1", label: "1 an" },
          { value: "2", label: "2 ani" },
          { value: "nedeterminata", label: "Nedeterminata" },
        ]}
        half
      />
    </div>
  );
}

export { CONF_OPTIONS };
